// extracted by mini-css-extract-plugin
export default {"button":"QuickActionButton_button__DUnVE","icon":"QuickActionButton_icon__UrvCo"};